import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { AcceptInvitationPage } from '@/features/auth';

/** Public. `token` comes from the invitation e-mail; the page keeps it in memory and strips it from the URL. */
export const Route = createFileRoute('/accept-invitation')({
  validateSearch: z.object({ token: z.string().max(200).optional() }),
  component: function AcceptInvitation() {
    const { token } = Route.useSearch();
    return <AcceptInvitationPage token={token} />;
  },
});
